import { connect } from "react-redux";
import React from "react";
import FilterGroup from "components/organisms/FilterGroup";
import OptionFilter from "containers/OptionFilter";
import CascadeFilter from "containers/CascadeFilter";
import { APP_FILTER_TYPES } from "constants/filter";
import config from "config";

const filterTypeMap = new Map([
  [APP_FILTER_TYPES.SINGLE, { component: OptionFilter, props: {} }],
  [APP_FILTER_TYPES.MULTIPLE, { component: OptionFilter, props: {} }],
  [APP_FILTER_TYPES.CASCADE, { component: CascadeFilter, props: {} }],
]);

const getFilterContainers = (filters, state, forceActive = false) => {
  if (!state.filters) {
    return [];
  }

  const getFilterType = (name) => {
    if (!state.filters[name]) {
      return;
    }
    return state.filters[name].filterType;
  };
  return filters.reduce((acc, f, index) => {
    const filterName = typeof f === "object" && f.name ? f.name : f;
    const filterType = getFilterType(filterName);
    let componentInfo;
    const userProps =
      typeof f === "object"
        ? Object.keys(f).reduce((acc, key) => {
            if (key !== "name") acc[key] = f[key];
            return acc;
          }, {})
        : {};

    if (typeof f === "object" && f.options) {
      acc.push(
        <OptionFilter
          key={index}
          name={filterName}
          label={f.label}
          options={f.options}
          className="sal-filtergroup__filter"
          forceActive={forceActive}
        />,
      );
      return acc;
    }

    if (filterType && (componentInfo = filterTypeMap.get(filterType))) {
      const Component = componentInfo.component;
      acc.push(
        <Component
          name={filterName}
          {...componentInfo.props}
          {...userProps}
          key={index}
          className="sal-filtergroup__filter"
          forceActive={forceActive}
        />,
      );
    }
    return acc;
  }, []);
};

const mapStateToProps = (state, ownProps) => {
  return {
    filters: getFilterContainers(ownProps.filters, state, ownProps.forceActive),
    actionUrl: config.baseurl,
    count: (state.result && state.result.totalCount) || 0,
    forceActive: ownProps.forceActive,
  };
};

const FilterGroupContainer = connect(mapStateToProps)(FilterGroup);

export default FilterGroupContainer;
